import { A365BackendModel as Model } from '../a365.backendmodel';
import { Metamodel } from '../base/model';
import { AdapterRegistry } from './adapter-registry';
import { ScopeJobDefinition, ScopeJobProperties } from '../scopejobdefinition/scopejobdefinition';
import { NamedAdapter } from './named.adapter';
import { ModelConstants } from '../model-constants';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(ScopeJobDefinition),
    adapts: {
        name: '*',
        properties: {
            description: '*',
            targetScopePool: '*',
            jobProperties: '*',
            folder: '*'
        }
    }
})
export class ScopeJobDefinitionAdapter extends NamedAdapter<ScopeJobDefinition, Model.ScopeJobDefinitionResource> {
    protected _toResource(model: ScopeJobDefinition): Model.ScopeJobDefinitionResource {
        const resource = super._toResource(model) as Model.ScopeJobDefinitionResource;
        const jobProperties = model.jobProperties
            ? {
                name: model.jobProperties.name,
                scriptPath: model.jobProperties.scriptPath,
                conf: model.jobProperties.conf
                    ? { ...model.jobProperties.conf }
                    : undefined,
                nebulaArguments: model.jobProperties.nebulaArguments,
                scriptParameters: model.jobProperties.scriptParameters
                    ? { ...model.jobProperties.scriptParameters }
                    : undefined,
                tags: model.jobProperties.tags
                    ? { ...model.jobProperties.tags }
                    : undefined,
                refFiles: model.jobProperties.refFiles
                    ? [...model.jobProperties.refFiles]
                    : undefined,
                runtimeName: model.jobProperties.runtimeName,
                parallelism: model.jobProperties.parallelism,
                parallelismPercent: model.jobProperties.parallelismPercent,
                ecoTokenParallelism: model.jobProperties.ecoTokenParallelism,
                ecoTokenParallelismPercent: model.jobProperties.ecoTokenParallelismPercent,
                defaultTokenPolicy: model.jobProperties.defaultTokenPolicy,
                notificationRecipients: model.jobProperties.notificationRecipients,
                priority: model.jobProperties.priority,
                maxUnavailability: model.jobProperties.maxUnavailability
            }
            : undefined;

        const properties = this.properties(resource);
        properties.targetScopePool = {
            referenceName: model.targetScopePool,
            type: 'ScopePoolReference'
        };
        properties.jobProperties = jobProperties;

        return resource;
    }

    protected _toModel(resource: Model.ScopeJobDefinitionResource, model?: ScopeJobDefinition): ScopeJobDefinition {
        if (!model) {
            model = ScopeJobDefinition.MODEL.create<ScopeJobDefinition>();
        }
        super._toModel(resource, model);
        model.resourceType = ModelConstants.scopeJobDefinition.toLowerCase() + 's';

        if (resource.properties) {
            model.targetScopePool = resource.properties.targetScopePool && resource.properties.targetScopePool.referenceName;
            const jobProperties = resource.properties.jobProperties;
            if (jobProperties) {
                model.jobProperties = new ScopeJobProperties();
                model.jobProperties.name = jobProperties.name;
                model.jobProperties.scriptPath = jobProperties.scriptPath;
                model.jobProperties.nebulaArguments = jobProperties.nebulaArguments;
                model.jobProperties.runtimeName = jobProperties.runtimeName;
                model.jobProperties.parallelism = jobProperties.parallelism;
                model.jobProperties.parallelismPercent = jobProperties.parallelismPercent;
                model.jobProperties.ecoTokenParallelism = jobProperties.ecoTokenParallelism;
                model.jobProperties.ecoTokenParallelismPercent = jobProperties.ecoTokenParallelismPercent;
                model.jobProperties.defaultTokenPolicy = jobProperties.defaultTokenPolicy;
                model.jobProperties.notificationRecipients = jobProperties.notificationRecipients;
                model.jobProperties.scriptParameters = jobProperties.scriptParameters
                    ? { ...jobProperties.scriptParameters }
                    : undefined;
                model.jobProperties.tags = jobProperties.tags
                    ? { ...jobProperties.tags }
                    : undefined;
                model.jobProperties.priority = jobProperties.priority;
                model.jobProperties.maxUnavailability = jobProperties.maxUnavailability;
                model.jobProperties.refFiles = jobProperties.refFiles
                    ? [...jobProperties.refFiles]
                    : undefined;
                model.jobProperties.conf = jobProperties.conf
                    ? { ...jobProperties.conf }
                    : undefined;
            }
        }

        return model;
    }
}
